import { IStyle, classNamesFunction } from '@fluentui/react';
import { IThemedProp } from './themesUI';

export interface IOutdatedDevicesAlertStyles {
  outdatedDevicesAlertContainer: IStyle;
  outdatedDeviceAlert: IStyle;
  outdatedDeviceAlertMain: IStyle;
  outdatedDeviceAlertMessage: IStyle;
  outdatedDeviceAlertExpandIcon: IStyle;
  outdatedDevicelist: IStyle;
  outdatedDeviceSuggestions: IStyle;
  expandAlertLink: IStyle;
  closeAlertLink: IStyle;
  windowsUpdateArticleLink: IStyle;
  updateDeviceButton: IStyle;
  outdatedDeviceContainer: IStyle;
  outdatedDevice: IStyle;
  deviceLogoAndInfo: IStyle;
  deviceLogo: IStyle;
  deviceInfo: IStyle;
  deviceName: IStyle;
  deviceModel: IStyle;
  deviceStatus: IStyle;
  deviceDivider: IStyle;
  overflowTextElement: IStyle;
}

export const getOutdatedDevicesAlertStyles = (props: IThemedProp): IOutdatedDevicesAlertStyles => {
  const { theme } = props;
  return {
    outdatedDevicesAlertContainer: {
      minWidth: '540px',
      textAlign: 'start',
      paddingBottom: '24px',
    },
    outdatedDeviceAlert: {
      backgroundColor: theme.palette.neutralLighter,
      color: theme.palette.neutralPrimary,
      i: { color: '#005a9e' },
    },
    outdatedDeviceAlertMain: {
      display: 'flex',
      alignItems: 'flex-start',
      paddingBottom: '8px',
    },
    outdatedDeviceAlertMessage: {
    },
    outdatedDeviceAlertExpandIcon: {
      i: {
        color: '#323130',
        fontSize: '10px',
        marginBottom: '16px',
      },
    },
    outdatedDevicelist: {
    },
    outdatedDeviceSuggestions: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: '8px',
      a: { paddingTop: '4px' },
    },
    expandAlertLink: {
      maxWidth: '220px',
    },
    closeAlertLink: {
      maxWidth: '130px',
    },
    windowsUpdateArticleLink: {
      maxWidth: '200px',
    },
    updateDeviceButton: {
      maxWidth: '180px',
      fontSize: '12px',
    },
    outdatedDeviceContainer: {
    },
    outdatedDevice: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '8px',
    },
    deviceLogoAndInfo: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    deviceLogo: {
      width: '20px',
    },
    deviceInfo: {
      width: '300px',
    },
    deviceName: {
    },
    deviceModel: {
      color: '#605E5C',
    },
    deviceStatus: {
      width: '120px',
    },
    deviceDivider: {
      hr: {
        margin: '0',
        borderTop: '1px solid #ccc',
      },
    },
    overflowTextElement: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  };
};

export const getOutdatedDevicesAlertClassNames = classNamesFunction<{}, IOutdatedDevicesAlertStyles>();
